export default {
  name: 'FeatureBox',
  props: {
    buttonColor: {
      type: String,
      validator: value => ['orange', 'white'].includes(value),
    },
    buttonText: String,
    description: String,
    image: String,
    title: String,
    to: [Object, String],
  },
  computed: {
    isNuxtLink() {
      return !this.to.startsWith('#')
    },
  },
}
